import React from 'react'
import { string } from 'prop-types'

import Icon from '../Icon'
import ShrinkWrap from '../ShrinkWrap'
import ButtonStandard from '../ButtonStandard'
import styles from './ArticleEventRegistration.module.scss'

class ArticleEventRegistration extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isEventbriteInitialised: false
    }

    this.fetchEBWidgets = this.fetchEBWidgets.bind(this)
  }

  fetchEBWidgets() {
    return new Promise((resolve) => {
      if (window.EBWidgets) return resolve(window.EBWidgets)

      const script = document.createElement('script')

      script.async = true
      script.id = 'eventbrite-embed'
      script.src = 'https://www.eventbrite.co.uk/static/widgets/eb_widgets.js'
      script.addEventListener('load', () => resolve(window.EBWidgets))

      document.head.appendChild(script)
    })
  }

  async componentDidMount() {
    try {
      const eventId = this.props.eventbriteId

      if (!eventId) return

      const eventBrite = await this.fetchEBWidgets()
      const triggerId = `eventbrite-trigger--${eventId}`

      eventBrite.createWidget({
        modal: true,
        eventId: eventId,
        widgetType: 'checkout',
        onOrderComplete: this.onSuccess,
        modalTriggerElementId: triggerId
      })

      this.setState({ isEventbriteInitialised: true })
    } catch (err) {
      this.setState({ isEventbriteInitialised: false })
    }
  }

  componentWillUnmount() {
    const script = document.getElementById('eventbrite-embed')
    if (script) script.remove()
  }

  render() {
    const { eventbriteId } = this.props

    if (!eventbriteId) return null

    return (
      <ButtonStandard
        outline
        secondary
        className={styles.ArticleEventRegistration}
        id={`eventbrite-trigger--${eventbriteId}`}
      >
        <ShrinkWrap>
          <ShrinkWrap.Item>Register now</ShrinkWrap.Item>
          <ShrinkWrap.Item shrink>
            <Icon type="arrow-right" />
          </ShrinkWrap.Item>
        </ShrinkWrap>
      </ButtonStandard>
    )
  }
}

ArticleEventRegistration.propTypes = {
  eventbriteId: string
}

export default ArticleEventRegistration
